
  export default {
    computed: {
      current () {
        return this.$store.getters['products/get'];
      }
    }
  };
